interface LotusIconProps {
  size?: number;
  className?: string;
}

export const LotusIcon = ({ size = 60, className = "text-gold fill-current" }: LotusIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 60 60" className={className}>
      <path d="M30 10 Q20 20 30 30 Q40 20 30 10" transform="rotate(0 30 30)" />
      <path d="M30 10 Q20 20 30 30 Q40 20 30 10" transform="rotate(45 30 30)" />
      <path d="M30 10 Q20 20 30 30 Q40 20 30 10" transform="rotate(90 30 30)" />
      <path d="M30 10 Q20 20 30 30 Q40 20 30 10" transform="rotate(135 30 30)" />
      <path d="M30 10 Q20 20 30 30 Q40 20 30 10" transform="rotate(180 30 30)" />
      <path d="M30 10 Q20 20 30 30 Q40 20 30 10" transform="rotate(225 30 30)" />
      <path d="M30 10 Q20 20 30 30 Q40 20 30 10" transform="rotate(270 30 30)" />
      <path d="M30 10 Q20 20 30 30 Q40 20 30 10" transform="rotate(315 30 30)" />
      <circle cx="30" cy="30" r="5" className="text-gold-light" fill="currentColor" />
      <path d="M30 8 Q28 15 30 22 Q32 15 30 8" fill="currentColor" />
    </svg>
  );
};